import React from 'react';
import ReactDOM from 'react-dom'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Session from '../services/session'
import i from '../imports';
import Moment from 'react-moment';

let cfg = require('../config');
var moment = require('moment');



const floatingLabelStyle = {
  color: "#BDBDBD"
}

const underlineStyle = {
  borderColor: "#FF5563"
}

const floatingLabelStyleInForm = {
  color: "#BDBDBD"
}

class FormDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      hasBeenSent: false,
      serverError: undefined,  
      nameError: undefined,
      emailError: undefined
    }

    this.reqField =  Session.model.common.request.requiredFieldMessage ? Session.model.common.request.requiredFieldMessage : 'Required field';
  }

  handleOpen = () => {
    this.setState({ 
      open: true,
      hasBeenSent: false, 
    });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      hasBeenSent: false 
    });
      this.props.onClose();

    if (this.props.updateCalcValues) {
      this.props.updateCalcValues(this.props.calcValues)
    }
  };

  componentWillReceiveProps(nextProps) {
  //  let nameErr = nextProps.nameValue ?  undefined : reqField;
  //   let emailErr = nextProps.emailValue ?  undefined : reqField;

    this.setState({
      open: nextProps.openDialog,
      hasBeenSent: false,
      serverError: undefined,
      calcValues: nextProps.calcValues,
      requestType: nextProps.requestType,
      nameValue: undefined,
      emailValue: undefined,
      phoneValue: 'empty',
      messageValue: 'empty',
      nameError: undefined,
      emailError: undefined
    });
  }

  handleNameChange = (event, value) => {
    let nameErr = value ?  undefined : this.reqField;
    this.setState({
        nameValue: value,
        nameError: nameErr,     
    });
  }

  handleEmailChange = (event, value) => {
    let emailErr = value ?  undefined : this.reqField;
    this.setState({
        emailValue: value,
        emailError: emailErr

    });
  }

  handlePhoneChange = (event, value) => {
    this.setState({
        phoneValue: value
    });
  }

  handleMessageChange = (event, value) => {
    this.setState({
        messageValue: value
    });
  }

  handleClickClose = (event) => {
    this.handleClose();
  }

  handleSubmit = (event) => {  
    event.preventDefault();
    if(this.state.nameValue && this.state.emailValue)
      this.sendRequest();
    else{
      let nameErr = this.state.nameValue ?  undefined : this.reqField;
      let emailErr = this.state.emailValue ?  undefined :  this.reqField;
      this.setState({
          nameError: nameErr,
          emailError: emailErr
    });

      
    }
  };

  sendRequest = ()=>{
    Date.prototype.toJSON = function(){return moment(this).format("DD/MM/YY")}
    fetch(cfg.requestSubmitUrl, {
    method: "post",
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        name: this.state.nameValue,
        email: this.state.emailValue,
        phone: this.state.phoneValue,
        message: this.state.messageValue,
        requestType: this.state.requestType,
        additionalData: this.props.calcValues

    })
    })
    .then( (response) => { 
      this.setState({
        hasBeenSent: true
      })        
    })
    .catch( (error) => {
      let errMessage = Session.model.common.request.commonErrorMessage ? Session.model.common.request.commonErrorMessage : 'Your request cannot be sent at the moment, please try again later.';
      this.setState({
        hasBeenSent: true,
        serverError: errMessage
      })
    });
  }


  render() {
    const actions = [
      <button
        className='button-dialog-submit'
        style={{ textAlign: "center" }}
        label="Submit"
        primary={'true'}
        disabled={false}
        onClick={this.handleSubmit}
      >{Session.model.flightTrains.button}</button>,
    ];
    const okButton = [
      <button
      className='button-dialog-submit'
      style={{ textAlign: "center" }}
      label="Submit"
      primary={'true'}
      disabled={false}
      onClick={this.handleClose}
    >{'Ok'}</button>
    ];

    return (
      <Dialog
        autoScrollBodyContent = {true}
        onClick={this.handleClickOutSide}
        onKeyDown={this.handleEscape}
        actionsContainerStyle={{ textAlign: "center" }}
        actions={this.state.hasBeenSent ? okButton: actions}
        modal={false}
        open={this.state.open}
        tabIndex="0"
        onRequestClose={this.handleClickClose}
      >
      {this.state.hasBeenSent == true ? 
        
        <i.Container>
        <i.Col>
          <i.Row>
            <i.Col style={{ fontWeight: 600, color: "#FF5563", fontSize: 24 }}>
              {this.state.serverError ? Session.model.common.words.error ? Session.model.common.words.error : 'Error' : '' }
            </i.Col>
          </i.Row>
            <i.Row>
              <i.Col>
                {this.state.serverError ? this.state.serverError : Session.model.common.request.commonSuccessMessage ? Session.model.common.request.commonSuccessMessage: 'Your message has been submitted. Thank you for your request!'}
              </i.Col>
            </i.Row>
          </i.Col>
        </i.Container>
        :
        <i.Container>
          <i.Col>
            <i.Row>
              <i.Col style={{ fontWeight: 600, color: "#FF5563", fontSize: 24 }}>
                {this.props.form_title}
              </i.Col>
            </i.Row>
            <i.Row>
              <i.Col>
                {this.props.form_description}
              </i.Col>
            </i.Row>
            <i.Row>
              <i.Col>
                <br />
              </i.Col>
            </i.Row>
            {this.props.children}
            <i.Row>
              <i.Col>
                <br />
              </i.Col>
            </i.Row>
            <i.Row align="end">
                <i.Col xs={12} md={12}>
                  <i.TextField
                      underlineFocusStyle={underlineStyle}
                      underlineStyle={underlineStyle}
                      floatingLabelStyle={floatingLabelStyleInForm}
                      floatingLabelText={Session.model.common.words.request_text}
                      multiLine={true}
                      rows={1}
                      rowsMax={5}
                      fullWidth
                  // value={this.state.priceFromValue} 
                      onChange={this.handleMessageChange} 
                  />
                </i.Col>
              </i.Row>
            <i.Row style={{ fontWeight: 600, color: "#FF5563", marginTop: 10 }}>
              <i.Col>
                {Session.model.common.words.your_contact_details}
              </i.Col>
            </i.Row>
            <i.Row align="end">
              <i.Col xs={4} md={4}>
                <i.TextField
                  underlineFocusStyle={underlineStyle}
                  underlineStyle={underlineStyle}
                  floatingLabelStyle={floatingLabelStyle}
                  floatingLabelText={Session.model.common.words.name}
                  errorText = {this.state.nameError}
                  errorStyle={{
                    float: "left"
                    }}
                  fullWidth
                  //value={this.state.priceFromValue} 
                  onChange={this.handleNameChange} 
                />
              </i.Col>
              <i.Col xs={4} md={4}>
                <i.TextField
                  underlineFocusStyle={underlineStyle}
                  underlineStyle={underlineStyle}
                  floatingLabelStyle={floatingLabelStyle}
                  floatingLabelText={Session.model.common.words.email}
                  errorText = {this.state.emailError}
                  errorStyle={{
                    float: "left"
                    }}
                  fullWidth
                // value={this.state.priceFromValue} 
                  onChange={this.handleEmailChange} 
                />
              </i.Col>
              <i.Col xs={4} md={4}>
                <i.TextField
                  underlineFocusStyle={underlineStyle}
                  underlineStyle={underlineStyle}
                  floatingLabelStyle={floatingLabelStyle}
                  floatingLabelText={Session.model.common.words.phone}
                  fullWidth
                // value={this.state.priceFromValue} 
                  onChange={this.handlePhoneChange} 
                />
              </i.Col>
            </i.Row>
          </i.Col>
        </i.Container>
      }
      </Dialog>
    );
  }
}
export default FormDialog;